<template>
    <div class="sticky-disclaimer" :class="{ short: !showLongDisclaimer }">
        <div v-if="!isDetectedMobileDevice" class="cookies-container">
            <Cookies />
        </div>
        <div
            class="sticky-disclaimer__wrapper"
            :class="{ short: !showLongDisclaimer }"
        >
            <div class="sticky-disclaimer__container">
                <div class="sticky-disclaimer__text">
                    <p v-if="showLongDisclaimer">
                        {{ $t(`${TRANSLATION_KEY}.line1`) }}
                    </p>
                    <p>
                        <strong v-if="!isMobile || showLongDisclaimer">{{
                            $t(`${TRANSLATION_KEY}.line2`)
                        }}</strong>
                        <strong v-else="!isMobile || showLongDisclaimer">{{
                            $t(`${TRANSLATION_KEY}.line2-short`)
                        }}</strong>
                    </p>
                    <p v-if="showLongDisclaimer">
                        {{ $t(`${TRANSLATION_KEY}.line3`) }}
                    </p>
                </div>
                <div
                    class="sticky-disclaimer__close"
                    :class="{ rotate: !showLongDisclaimer }"
                >
                    <button
                        type="button"
                        class="sticky-disclaimer__toggle"
                        tabindex="-1"
                        aria-label="Toggle disclaimer"
                        @click="handleDisclaimer"
                    >
                        <img src="@/assets/pointer-black-thick.svg" alt="" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import Cookies from '@/components/basic/Cookies.vue';

export default defineComponent({
    name: 'StickyDisclaimer',
    components: {
        Cookies,
    },
    setup() {
        const store = useStore();
        const isMobile = ref(false);
        const TRANSLATION_KEY = 'Disclaimer';

        const showLongDisclaimer = computed(
            () => store.state.showLongDisclaimer
        );
        const isDetectedMobileDevice = computed(
            () => store.state.isDetectedMobileDevice
        );

        const handleDisclaimer = () => {
            store.state.showLongDisclaimer = !store.state.showLongDisclaimer;
        };

        const onResize = () => {
            isMobile.value = window.innerWidth < 768;
        };

        onMounted(() => {
            window.addEventListener('resize', onResize);
            onResize();
        });

        return {
            isMobile,
            TRANSLATION_KEY,
            showLongDisclaimer,
            isDetectedMobileDevice,
            handleDisclaimer,
        };
    },
});
</script>

<style scoped lang="scss">
.sticky-disclaimer {
    position: fixed;
    bottom: 0;
    z-index: 11;
    width: 100%;
    line-height: 1;
    &__wrapper {
        padding-top: 20px;
        padding-bottom: 17px;
        padding-left: 15px;
        padding-right: 15px;
        width: 100%;
        background-color: #f2f2f2;
        &.short {
            padding-top: 10px;
            padding-bottom: 7px;
        }
    }
    &__container {
        max-width: 1140px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        gap: 5px;
    }
    p {
        margin: 0;
        @media (max-width: 767px) {
            font-size: 11px;
        }
    }
    &__close {
        img {
            cursor: pointer;
            min-width: 10px;
            min-height: 12px;
            transform: rotate(90deg);
            transition: 0.3s;
        }
        &.rotate img {
            transform: rotate(270deg);
        }
    }
    &__toggle {
        padding: 0;
        border: none;
        background: transparent;
    }
    &__text p {
        font-size: 13px;
        @media (max-width: 767px) {
            font-size: 14px;
        }
    }
}
</style>
